import { call, delay, put } from 'redux-saga/effects';
import VEHICLE_CAPABLE_ACTION from '../actionTypes/VehicleCapable';
import VehicleCapableApi from '../apis/VehicleCapableApi';


/**
 * @name get vehicle capability
 * @description vehicle capability status
 */
export function* getVehicleCapable() {
  try {
    const response = yield call(VehicleCapableApi.get);
    yield delay(3000);
    const payload = response || {};
    yield put({
      type: VEHICLE_CAPABLE_ACTION.VEHICLE_CAPABLE_SUCCESS,
      payload: payload.capabilities.find(obj => obj.name === 'RemoteCapable').value,
    });
  } catch (error) {
    yield put({
      type: VEHICLE_CAPABLE_ACTION.VEHICLE_CAPABLE_ERROR,
      error,
    });
  }
}
